import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { ViewSignIn } from '@view/view_sign_in';
import { createRoot, Root } from 'react-dom/client';
import { Route, Routes } from 'react-router-dom';
import { StartupService } from '../app/Services/app/startup.service';
import { SpaEventService } from '../app/Services/spaEvents.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'SignInWrapper';

@Component({
	standalone: false,
	selector: 'sign-in-wrapper',
	template: `<semantic-view>
		<header-component header></header-component>
		<div class="wrapper-container" #${containerElementName}></div>
		<footer-component footer></footer-component>
	</semantic-view>`,
	encapsulation: ViewEncapsulation.None,
})
export class SignInWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;
	public extraHeaderHeight: boolean = false;

	constructor(
		private readonly ngZone: NgZone,
		// biome-ignore lint/correctness/noUnusedPrivateClassMembers: suppressed due to migration - should be fixed
		private readonly spaEventService: SpaEventService,
	) {}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private async render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ProgrammaticBrowserRouter forceNewHistory>
						<Routes>
							<Route
								path='*'
								element={
									<Flex
										style={{
											width: '100%',
											maxWidth: '600px',
											margin: '0 auto',
											padding: `${tokens.spacing.x4} 0`,
										}}
									>
										<ViewSignIn />
									</Flex>
								}
							/>
						</Routes>
					</ProgrammaticBrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}
